import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const googleCalendar = defineConnector({
  identifier: "googleCalendar",
  name: "Google Calendar",
  tagLine: "Calendar and event management",
  keywords: "gcal events meetings scheduling invites workspace g suite",
  logo,
  protocol: "http",
  tags: ["featured", "productivity"],
  defaultUrlPattern: () => "https://www\\.googleapis\\.com/calendar/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Connect your Google Calendar",
      items: [
        {
          kind: "oauth",
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://accounts.google.com/o/oauth2/v2/auth",
    tokenEndpoint: () => "https://oauth2.googleapis.com/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "env",
    authorizationParameters: () => ({
      access_type: "offline",
      prompt: "consent",
    }),
  },
  connectionTest: {
    protocol: "http",
    request: () =>
      "https://www.googleapis.com/calendar/v3/users/me/calendarList",
  },
});
